import EmployeeTrainingHistoryModal from './EmployeeTrainingHistoryModal';

export default EmployeeTrainingHistoryModal;
